import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

export const Route = createFileRoute('/_app/employers')({
  staticData: { crumb: 'nav.employers', crumbTo: '/employers' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'employer.view', 'Customer employers'),
  component: Outlet,
});
